<template>
  <div
    :class="['kpi_table--column--cell', rowClass, {'has_records': amount > 0}]"
    @click="openModal"
  >
    <p>{{ amountFormatted }}</p>

    <modal-before-container>
      <modal-default
        :title="label + ', ' + columnData.label"
        ref="recordList"
        is-wide
      >
        <TablePaginated :load-data="getRecords" :columns="tableColumns"/>
      </modal-default>
    </modal-before-container>
  </div>
</template>

<script>
import StatsKpiRecordItem from "./StatsKpiRecordItem";
import api from "../../../api";
import dates from "../../../services/dates";
import TablePaginated from "../../../components/table/TablePaginated.vue";
import router from "../../../router";
import utils from "../../../services/utils";

export default {
  name: "StatsKpiCellData",
  components: {TablePaginated, StatsKpiRecordItem},
  props: {
    columnData: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    goal: {
      type: String | Number | null,
      required: true
    },
    amount: {
      type: String | Number | null,
      required: true
    },
    recordsEndpoint: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      tableColumns: [
        {
          label: 'Address',
          onClick(record) {
            router.replace({query: {lead: record.id}});
            this.$refs.recordList.close();
          },
          display(record) {
            let label = 'Unknown Address'

            if (record.property.line_1 || record.property.city || record.property.state) {
              label = record.property.line_1;
              if (record.property.city) {
                label += ' ' + record.property.city;
              }
              if (record.property.city && record.property.state) {
                label += ',';
              }
              if (record.property.state) {
                label += ' ' + record.property.state;
              }
            }

            return `<span class="text-clickable" @click="openRecordModal(${record.id})">${label}</span>`
          }
        },
        {
          label: 'Contact',
          display(record) {
            if (!record.contact) {
              return;
            }

            const first = record.contact.first_name ? record.contact.first_name : '';
            const last = record.contact.last_name ? record.contact.last_name : '';
            const name = `${first} ${last}`;

            return name === ' ' ? 'Unknown Contact' : name;
          }
        },
        {
          label: 'Created At',
          display(record) {
            return dates.formatAsDate(record.created_at);
          }
        },
        {
          label: 'Created By',
          display(record) {
            return record.createdBy.display_name;
          }
        }

      ]
    }
  },
  computed: {
    amountFormatted() {
      if (this.amount) return utils.formatNumberWithComma(parseInt(this.amount))
      return '-'
    },
    rowClass() {
      const goal = this.goal ? parseInt(this.goal) : 0;
      const amount = this.amount ? parseInt(this.amount) : 0;

      if (goal === 0) {
        return ''
      } else if (amount === 0) {
        return 'is_light'
      } else if (amount >= goal) {
        return 'is_success'
      } else if (amount < goal) {
        return 'is_danger'
      }

      return ''
    },
  },
  methods: {
    openRecordModal(id) {
      router.replace({query: {lead: id}});
    },
    getRecords(query = '') {
      if (query.length !== 0) {
        query += `&`;
      }

      query += `start_at=${this.columnData.startAt}&end_at=${this.columnData.endAt}`;
      if (this.$store.state.statsKpi.filters.campaigns) {
        query += `&campaigns=${this.$store.state.statsKpi.filters.campaigns}`
      }

      if (this.$store.state.statsKpi.filters.users) {
        query += `&users=${this.$store.state.statsKpi.filters.users}`
      }

      return api.stats.getKPIStatRecords(this.recordsEndpoint, query);
    },
    openModal() {
      if (this.amount === 0) return;
      this.$refs.recordList.open();
      this.getRecords();
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.kpi_table--column--cell {

  &.has_records {
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }

  &.is_light {
    color: $text-light !important;
  }

  &.is_success {
    color: $success !important;
  }

  &.is_danger {
    color: $danger !important;
  }
}

.record_list {
  position: relative;
  min-height: 80px;
}
</style>
